<template>
  <div class="page">
    <div class="query-conditions">
      <el-form
        :inline="true"
        class="query-form"
        @submit.native.prevent
      >
        <el-row
          :gutter="20"
          class="query-row"
        >
          <el-col
            v-show="queryFieldVisibility.budget_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.budget_name"
                clearable
                placeholder="请输入聚合名称"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.identify_code"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.identify_code"
                clearable
                placeholder="请输入识别名称"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.owner_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.owner_name"
                clearable
                placeholder="请输入所属"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.product_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model="query.form.product_name"
                clearable
                placeholder="请输入产品名称"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.release_time"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <DatePicker
                v-model="query.form.release_time"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.sale_type"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.form.sale_type"
                clearable
                style="width: 100%;"
                placeholder="请选择预算类型"
              >
                <el-option
                  v-for="item in saleTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            :span="queryActionSpan"
            class="query-item query-item--actions"
          >
            <div class="query-buttons">
              <el-button
                plain
                type="primary"
                :loading="table.loading"
                @click="handleReset"
              >
                重置
              </el-button>

              <el-button
                type="primary"
                :loading="table.loading"
                @click="handleFilter"
              >
                查询
              </el-button>

              <el-button
                v-if="showQueryToggle"
                type="text"
                class="query-toggle"
                @click="toggleQueryExpand"
              >
                {{ queryExpanded ? '收起' : '展开' }}
                <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <el-alert
        title="仅展示当前尚未释放，且预计在今天至未来7个自然日内释放的聚合。聚合释放后将从公示列表中移除。"
        type="info"
        :closable="false"
        show-icon>
      </el-alert>

    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <el-table
        ref="aggregationTable"
        stripe
        border
        :data="table.list"
        :row-key="row => row.id"
        style="width: 100%"
        empty-text="暂无符合条件且即将释放的聚合"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="200"
        />

        <el-table-column
          prop="identify_code"
          label="识别名称"
          width="300"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.identifyCodeList.length"
              class="tag-list"
            >
              <el-tag
                class="no-wrap-tag"
                type="success"
              >
                {{ scope.row.identifyCodeList[0] }}
              </el-tag>

              <el-popover
                v-if="scope.row.identifyCodeList.length > 1"
                placement="top"
                width="400"
                trigger="click"
              >
                <div class="tag-popover">
                  <el-tag
                    v-for="item in scope.row.identifyCodeList"
                    :key="item"
                    type="success"
                  >
                    {{ item }}
                  </el-tag>
                </div>
                <el-button
                  slot="reference"
                  type="text"
                  style="flex: 1;"
                >
                  更多
                </el-button>
              </el-popover>
            </div>

            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="product_names"
          label="产品名称"
          width="160"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.productNameList.length"
              class="tag-list tag-list--compact"
            >
              <el-tag
                class="no-wrap-tag"
                type="success"
              >
                {{ scope.row.productNameList[0] }}
              </el-tag>

              <el-popover
                v-if="scope.row.productNameList.length > 1"
                placement="top"
                width="400"
                trigger="click"
              >
                <div class="tag-popover">
                  <el-tag
                    v-for="item in scope.row.productNameList"
                    :key="item"
                    type="success"
                  >
                    {{ item }}
                  </el-tag>
                </div>
                <el-button
                  slot="reference"
                  type="text"
                  style="flex: 1;"
                >
                  更多
                </el-button>
              </el-popover>
            </div>

            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="subject_type"
          label="主体类型"
          width="120"
        >
          <!-- <template slot-scope="scope">
            <div>{{ scope.row.subjectTypeLabel }}</div>
          </template> -->
        </el-table-column>

        <el-table-column
          prop="sale_type"
          label="预算类型"
          width="120"
        >
          <!-- <template slot-scope="scope">
            <div>{{ scope.row.saleTypeLabel }}</div>
          </template> -->
        </el-table-column>

        <el-table-column
          prop="owner_name"
          label="所属"
          min-width="120"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.ownerNameText }}
          </template> -->
        </el-table-column>

        <el-table-column
          prop="release_time"
          label="预计释放时间"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.release_time || '-' }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Request from '@/core/QuRequest';
import queryGridByContainer from '@/common/js/queryGridByContainer';
import DatePicker from './components/DatePicker/Index.vue';

const req = new Request();

const SALE_TYPE_OPTIONS = [
  { label: '全部', value: '' },
  { label: '直投', value: '1' },
  { label: '渠道', value: '2' },
];
function hasValue(value) {
  if (value === 0 || value === '0' || value === false) return true;
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

function safeTrim(value) {
  if (typeof value === 'string') return value.trim();
  if (value === undefined || value === null) return '';
  return String(value).trim();
}

function splitTextList(value) {
  return safeTrim(value)
    .replace(/[，,]/g, ',')
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);
}

export default {
  name: 'AggregationManagePublicNotice',
  mixins: [queryGridByContainer],
  components: {
    DatePicker
  },
  data() {
    return {
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      queryExpanded: true,
      userInfo: {},
      query: {
        form: {
          page: 1,
          page_size: 10,
          budget_name: '',
          identify_code: '',
          owner_name: '',
          product_name: '',
          release_time: [],
          sale_type: '',
        },
      },
      productsLoading: false
    };
  },
  computed: {
    saleTypeOptions() {
      return SALE_TYPE_OPTIONS;
    },
    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },
    collapsedQueryCount() {
      return Math.min(
        Math.max(this.queryColumnsPerRow - 1, 1),
        this.queryFieldKeys.length,
      );
    },
    visibleQueryFieldCount() {
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },
    queryActionSpan() {
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns = remainder === 0
        ? this.queryColumnsPerRow
        : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },
    queryFieldKeys() {
      const keys = ['budget_name', 'identify_code', 'owner_name'];
      return keys.concat(['product_name', 'release_time', 'sale_type']);
    },
    queryFieldVisibility() {
      const visibility = {};

      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });

      return visibility;
    },
    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },
    getSaleTypeLabel(value) {
      const hit = this.saleTypeOptions.find(item => item.value === `${value}`);
      return hit ? hit.label : '--';
    },
    getSubjectTypeLabel(value) {
      if (`${value}` === '1') return '个人';
      if (`${value}` === '2') return '公司';
      return '--';
    },
    getOwnerNameText(item = {}) {
      const owners = Array.isArray(item.owners) ? item.owners : [];
      if (!owners.length) {
        return '-';
      }
      return owners
        .map(owner => owner.owner_name)
        .filter(Boolean)
        .join(',') || '-';
    },
    normalizeRow(item = {}) {
      return {
        ...item,
        identifyCodeList: splitTextList(item.identify_code),
        productNameList: splitTextList(item.product_name),
        subjectTypeLabel: this.getSubjectTypeLabel(item.subject_type),
        saleTypeLabel: this.getSaleTypeLabel(item.sale_type),
        ownerNameText: this.getOwnerNameText(item),
      };
    },
    buildListParams(option = {}) {
      const form = this.query.form;

      const params = {
        page: Number(form.page) || 1,
        page_size: Number(form.page_size) || 10,
        ...option,
      };

      if (hasValue(form.budget_name)) {
        params.budget_name = safeTrim(form.budget_name);
      }

      if (hasValue(form.identify_code)) {
        params.identify_code = safeTrim(form.identify_code);
      }

      if (hasValue(form.owner_name)) {
        params.owner_name = safeTrim(form.owner_name);
      }

      if (hasValue(form.product_name)) {
        params.product_name = safeTrim(form.product_name);
      }

      if (hasValue(form.release_time)) {
        params.release_time_start = moment(form.release_time[0]).format('YYYY-MM-DD');
        params.release_time_end = moment(form.release_time[1]).format('YYYY-MM-DD');
        delete params.release_time;
      }

      if (hasValue(form.sale_type)) {
        params.sale_type = form.sale_type;
      }

      if (this.$route.query.id) {
        params.id = Number(this.$route.query.id || 0);
      }

      return params;
    },
    clearAggregationSelection() {
      if (this.$refs.aggregationTable) {
        this.$refs.aggregationTable.clearSelection();
      }
    },
    async getUserInfo() {
      const res = await req.send(req.Apis.sales.user.userInfo);
      if (res.code === 200) {
        this.userInfo = res.data || {};
      }
    },

    async _getList(option = {}) {
      try {
        this.table.loading = true;
        const res = await req
          .send(
            req.Apis.customer.aggregation.noticeList,
            this.buildListParams(option),
          )
          .fin(() => {
            this.table.loading = false;
          });

        const data = res.data || {};
        const list = Array.isArray(data.list) ? data.list : [];

        this.table.list = list.map(item => this.normalizeRow(item));
        this.table.total = Number(data.total || 0);
      } catch (err) {
        this.table.loading = false;
        this.$message.error(`获取用户列表失败：${err.message || '未知错误'}`);
      }
    },
    handleFilter() {
      this.query.form.page = 1;
      this.clearAggregationSelection();
      this._getList();
    },
    handleReset() {
      this.query.form.budget_name = '';
      this.query.form.identify_code = '';
      this.query.form.owner_name = '';
      this.query.form.product_name = '';
      this.query.form.release_time = [];
      this.query.form.sale_type = '';
      this.query.form.page = 1;
      this.clearAggregationSelection();
    },
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },
    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },
  },
};
</script>

<style lang="less" scoped>
.query-conditions {
  margin-bottom: 24px;
}

.query-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 0;
}

.query-row {
  flex: 1 1 720px;
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  align-items: flex-start;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

.tag-list {
  display: flex;
  justify-content: space-between;
  width: 280px;
  gap: 8px;
}

.tag-list--compact {
  width: 140px;
}

.tag-popover {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  max-height: 400px;
  overflow: auto;
}

/deep/ .tag-popover .el-tag {
  margin-right: 8px;
}

/deep/ .query-conditions .el-form-item {
  display: block;
  margin-right: 0;
  margin-bottom: 0;
}

/deep/ .query-conditions .el-form-item__content {
  display: block;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

.no-wrap-tag {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
